import './Home.scss';

import Block2 from 'images/home/Block2.png';
import Block3 from 'images/home/Block3.png';
import Block4 from 'images/home/Block4.png';
import Block5 from 'images/home/Block5.png';
import CTA from 'images/home/cta.png';
import Home1 from 'images/home/Home-landing.webp';
import Icon1 from 'images/home/Icon1.png';
import Icon2 from 'images/home/Icon2.png';
import Icon3 from 'images/home/Icon3.png';
import Quote from 'images/home/Quote.png';
import { Footer } from 'organisms/Footer';
import { MiniNavbar } from 'organisms/MiniNavbar';
import { GET_STARTED_SCHEDULING_URL } from 'util/urls';

export default function Home() {
  const block1 = [
    {
      title: 'Discover new clients',
      description:
        'PawCare enables customers to discover your grooming business.',
      img: Icon1,
    },
    {
      title: 'Calendar management',
      description: 'Control your schedule with your own dedicated profile.',
      img: Icon2,
    },
    {
      title: 'Reduce no shows',
      description:
        'Earn additional revenue on missed appointments and late cancellations.',
      img: Icon3,
    },
  ];
  return (
    <div className="flex-column w-100 margin-center overflow-scroll">
      <MiniNavbar />
      <div className="home">
        <div className="home-padding">
          <div className="flex-row justify-between home-header">
            <div className="home-header-description">
              <h1>Simplify your grooming business</h1>
              <p>
                PawCare is flexible and user friendly software to drive bookings
                and grow revenue.
              </p>
              <a
                href={GET_STARTED_SCHEDULING_URL}
                target="_blank"
                rel="noreferrer"
                className="button flex-row button--large button--round button--default w-fit"
              >
                Get started
              </a>
            </div>
            <img src={Home1} alt="decoration" />
          </div>
          <div className="home-block-1">
            <h2>How does it work?</h2>
            <div className="flex-row home-block-1-container justify-between">
              {block1.map((item) => (
                <div
                  key={item.title}
                  className="flex-column ptb-65 align-center home-block-1-container-item"
                >
                  <img src={item.img} alt="decorative" />
                  <h4 className="bold">{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="home-block-2">
            <div className="flex-row justify-between home-block-2-container">
              <img src={Block2} alt="decorative" />
              <div
                className="home-block-2-container-quote"
                style={{ backgroundImage: `url(${Quote})` }}
              >
                <p>
                  PawCare has positively affected my business: new clients with
                  great pets! It&apos;s an amazing relationship.
                </p>
                <p className="mt-25">— DSPA Grooming</p>
              </div>
            </div>
          </div>
          <div className="home-block-3">
            <div className="flex-row justify-between home-block-3-container">
              <div className="home-block-3-container-description">
                <h4>More time grooming</h4>
                <p className="mt-12">
                  Optimize your calendar by auto-accepting incoming appointments
                  day or night, and spend more time with your clients.
                </p>
              </div>
              <img src={Block3} alt="decorative" />
            </div>
          </div>
          <div className="home-block-4">
            <div className="flex-row justify-between home-block-4-container">
              <img src={Block4} alt="decorative" />
              <div className="home-block-4-container-description">
                <h4>Schedule management</h4>
                <p className="mt-12">
                  Let your customers know your availability, easily add times
                  when you have a last minute cancelation, and add overrides for
                  when you want to go on vacation.
                </p>
              </div>
            </div>
          </div>
          <div className="home-block-5">
            <div className="flex-row justify-between home-block-5-container">
              <div className="home-block-5-container-description">
                <h4>Free iOS app</h4>
                <p className="mt-12">
                  Let your customers book and manage their relationship with you
                  directly from their phone.
                </p>
              </div>
              <img src={Block5} alt="decorative" />
            </div>
          </div>
        </div>
        <div className="home-block-6">
          <div className="home-block-6-container">
            <div
              className="home-block-6-container-cta flex-column align-center"
              style={{ backgroundImage: `url(${CTA})` }}
            >
              <h4>Sign up today for PawCare</h4>
              <p className="mt-10 mb-20">
                Let us help streamline your operations, reduce no shows, and
                allow you to spend more time doing what you love.
              </p>
              <a
                href={GET_STARTED_SCHEDULING_URL}
                target="_blank"
                rel="noreferrer"
                className="button flex-row button--large button--round button--white"
              >
                Get started
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
